'use strict';

import resizeStore from '../resize/resize.store';
import {prefixedCSSValue} from '../utils';
import Draggable from 'gsap/Draggable';
import SplitText from 'SplitText';

let grabbing = prefixedCSSValue('cursor', 'grabbing');
let grab = prefixedCSSValue('cursor', 'grab');


class MainSliderComponent extends HTMLElement{
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    const t = +this.dataset.auto;
    this._autoTime = !isNaN(t) && t > 0 ? t : 10;
    this._changing = false;
    this._slidesArr = [];
    this._active = undefined;
    this._dragX = 0;

    this.handleResize = () => this._onResize();
  }
  connectedCallback() {
    this._dragWrapper = this.querySelector('.ms-dragWrapper');
    this._dragBounds = this.querySelector('.ms-dragBounds');
    this._buttonsContainer = this.querySelector('.ms-buttons');
    this._prevButton = this.querySelector('.ms-prev');
    this._nextButton = this.querySelector('.ms-next');

    const slides = this.querySelectorAll('.ms-slide');

    if (slides.length <= 1) throw new Error('Где слайды для главного слайдера?');

    let activeNum = 0;

    Array.from(slides).forEach((element, i) => {
      const image = element.querySelector('.ms-image');
      const text = element.querySelector('.ms-text');
      const button = document.createElement('button');
      button.classList.add('ms-control');

      button.addEventListener('click', () => this._active.i !== i && this._change(this._active.i < i, i));

      const line = document.createElement('span');
      button.appendChild(line);

      this._buttonsContainer.appendChild(button);

      const timeLine = TweenMax.fromTo(line, this._autoTime, {
        scaleX: 0
      }, {
        scaleX: 1,
        paused: true,
        onComplete: () => this._change('next')
      });

      const obj = {
        element,
        i,
        image,
        text,
        button,
        line,
        timeLine
      };

      if (element.classList.contains('active')) activeNum = i;

      this._slidesArr.push(obj);
    });

    this._onResize();
    resizeStore.eventEmitter.subscribe(this.handleResize);

    if (!this._active) {
      setTimeout(() => this._firstInit(activeNum), 100)
    }


    this._draggable = Draggable.create(this._dragWrapper, {
      cursor: grab,
      activeCursor: grabbing,
      throwProps: true,
      type: 'x',
      bounds: this._dragBounds,
      edgeResistance: 1,
      snap: {
        x: value => {
          if (value <= -300) {
            this._change(true);
            // return -500;
          } else if (value >= 300) {
            this._change();
            // return 500;
          // } else {
          //   return 0;
          }
          return 0
        }
      },
      onPress: () => this._active.timeLine.pause(),
      onRelease: () => !this._changing && this._active.timeLine.play(),
      onDrag: () => {
        this._dragX = this._draggable.x / 10;

        if (this._dragX <= -300 / 10) {
          this._draggable.endDrag();
          this._change(true);
        } else if (this._dragX >= 300 / 10) {
          this._draggable.endDrag();
          this._change();
        }

        this._onUpdate();
      },

      onThrowUpdate: () => {
        this._dragX = this._draggable.x / 10;
        this._onUpdate();
      }
    })[0];

    this._prevButton.addEventListener('click', () => this._change());
    this._nextButton.addEventListener('click', () => this._change(true));
  }
  disconnectedCallback() {
    this._draggable.kill();
    resizeStore.eventEmitter.unsubscribe(this.handleResize);
  }

  _firstInit(activeNum) {
    this._active = this._slidesArr[activeNum];
    this._active.element.classList.add('active');
    this._active.timeLine.timeScale(1);
    this._active.timeLine.play(0);

    this.style.setProperty('--count', this._active.split.lines.length.toString());

    TweenMax.staggerFromTo(this._active.split.lines, 0.5, {
      x: 40,
      opacity: 0
    }, {
      x: 0,
      opacity: 1
    }, 0.05);

    this._firstInited = true;
  }

  _onResize() {
    let top = 0;

    this._slidesArr.forEach(slide => {
      if (slide.split) slide.split.revert();

      slide.split = new SplitText(slide.text, {type: 'lines'});
      if (!this._firstInited) TweenLite.set(slide.split.lines, {opacity: 0});

      top = Math.max(top, slide.split.lines.length);

      if (slide === this._active) {
        this.style.setProperty('--count', this._active.split.lines.length.toString());
      }
    });
  }

  _onUpdate() {
    if (this._changing) return;
    TweenLite.set(this._active.image, {x: this._dragX});
  }

  _change(next, num) {
    this.classList.add('changing');
    this._changing = true;
    this._draggable.disable();

    const old = this._active;
    old.element.classList.remove('active');
    old.timeLine.timeScale(10);
    old.timeLine.reverse();

    let nextSlide;
    let x;

    if (next) {
      x = 40;
      nextSlide = num || this._slidesArr[this._active.i + 1] ? this._active.i + 1 : 0;
      // slidesArr[nextSlide].element.transition = 'none';
      this._slidesArr[nextSlide].element.classList.add('fromRight');
    } else {
      x = -40;
      nextSlide = num || this._slidesArr[this._active.i - 1] ? this._active.i - 1 : this._slidesArr.length - 1;
      // slidesArr[nextSlide].element.transition = 'none';
      this._slidesArr[nextSlide].element.classList.add('fromLeft');
    }


    TweenLite.to(old.image, 0.5, {
      opacity: 0,
      x: -x * 2,
      scale: 1.05
    });
    TweenMax.staggerTo(old.split.lines, 0.8, {
      x: -x / 2,
      opacity: 0
    }, 0.05);



    this._active = this._slidesArr[nextSlide];
    this._active.timeLine.timeScale(1);
    this._active.timeLine.play(0);
    this.style.setProperty('--count', this._active.split.lines.length.toString());

    // this._activateSlide(newActive);

    TweenLite.fromTo(this._active.image, 0.5, {
      x: x,
      scale: 0.95,
      opacity: 0
    }, {
      x: 0,
      scale: 1,
      delay: 0.05,
      opacity: 1,
      onStart: () => {
        this._active.element.classList.add('active');
      },
      onComplete: () => {
        this._draggable.enable();

        this.classList.remove('changing');
        TweenLite.set(this._dragWrapper, {x: 0});

        this._active.element.classList.remove('fromRight', 'fromLeft');

        this._changing = false;
      }
    });

    TweenMax.staggerFromTo(this._active.split.lines, 0.5, {
      x: x,
      opacity: 0
    }, {
      x: 0,
      opacity: 1,
      delay: 0.2
    }, 0.05);
  }
}

window.customElements.define('main-slider', MainSliderComponent);